<!-- testing -->
<!-- <button mat-icon-button color="primary" (click)="setElementInGrid(ExampleGridElement)">
      <mat-icon>done</mat-icon>
    </button> -->
<!-- testing end -->
<!-- GridArray: {{GridArray | json}} -->
<!--
    rows: {{Rows}}
    cols: {{Cols}}-->
<!-- GridConfig: {{GridConfig | json}}  -->
<!-- <div style="height:100%" > -->
<div>
  <div *ngIf="true" onresize="resizer()">
    <mat-grid-list [cols]="Cols" [rowHeight]="rowHeight">
      <div *ngIf="!GridConfig.hasSpecial">
        <ng-container
          *ngFor="let _ of [].constructor(Cols * Rows); let i = index">
          <mat-grid-tile
            class="droppable gridDroppableZone"
            [id]="'grid-tile_' + i">
            <lib-i2v-video-grid
              *ngIf="
                gridMode=='general' && GridArray[i] != '' && GridArray[i].ComponentName == 'Video'
              "
              [idx]="GridArray[i].id"
              [playbackMode]="GridArray[i].playbackMode"
              [resource]="GridArray[i].camera"
              [options]="options"
              [playerServerIp]="playerServerIp"
              [streamerIp]="streamerIp"
              (VideoStartedFromi2vVideoGrid)="onVideoStarted($event)"
              (CloseLiveFeed)="closeElement($event)">
            </lib-i2v-video-grid>
            <lib-face-card *ngIf="gridMode == 'FRS' && GridArray[i] != ''" 
            [id]="GridArray[i].id" [eventObj]="GridArray[i]">
            </lib-face-card>
            <!-- <div *ngIf="gridMode == 'FRS' && GridArray[i] != ''" 
            [id]="GridArray[i].id">
            <img [src]="GridArray[i].Images[0].Path">
          </div> -->
          </mat-grid-tile>
        </ng-container>
      </div>
      <div *ngIf="GridConfig.hasSpecial">
        <mat-grid-tile
          class="droppable gridDroppableZone"
          [id]="'grid-tile_' + GridArray[0].id"
          [colspan]="GridConfig.SEWidth"
          [rowspan]="GridConfig.SEHeight">
          <lib-i2v-video-grid
            *ngIf=" gridMode=='general' && GridArray[0] != '' && GridArray[0].ComponentName == 'Video'"
            [idx]="GridArray[0].id"
            [resource]="GridArray[0].camera"
            [playerServerIp]="playerServerIp"
            [streamerIp]="streamerIp"
            (VideoStartedFromi2vVideoGrid)="onVideoStarted($event)"
            (CloseLiveFeed)="closeElement($event)">
          </lib-i2v-video-grid>
          <lib-face-card *ngIf="gridMode == 'FRS' && GridArray[0] != ''" 
          [id]="GridArray[0].id" [eventObj]="GridArray[0]">
          </lib-face-card>
          <!-- <div *ngIf="gridMode == 'FRS' && GridArray[0] != ''" 
          [id]="GridArray[0].id">
          <img [src]="GridArray[0].Images[0].Path">
        </div> -->
        </mat-grid-tile>
        <ng-container
          *ngFor="
            let _ of [].constructor(GridConfig.NumberofTiles - 1);
            let i = index
          ">
          <mat-grid-tile
            class="droppable gridDroppableZone"
            [id]="'grid-tile_' + GridArray[i + 1].id">
            <lib-i2v-video-grid
              *ngIf="  gridMode=='general' && 
                GridArray[i + 1] != '' &&
                GridArray[i + 1].ComponentName == 'Video'
              "
              [idx]="GridArray[i + 1].id"
              [resource]="GridArray[i + 1].camera"
              [playerServerIp]="playerServerIp"
              [streamerIp]="streamerIp"
              (VideoStartedFromi2vVideoGrid)="onVideoStarted($event)"
              (CloseLiveFeed)="closeElement($event)">
            </lib-i2v-video-grid>
            <lib-face-card *ngIf="gridMode == 'FRS' && GridArray[i] != ''" 
            [id]="GridArray[i].id" [eventObj]="GridArray[i]">

            </lib-face-card>
            <!-- <div *ngIf="gridMode == 'FRS' && GridArray[i] != ''" 
              [id]="GridArray[i].id">
            </div> -->
          </mat-grid-tile>
        </ng-container>
      </div>
    </mat-grid-list>
  </div>

  <div
    *ngIf="false"
    id="parentGridLiveView"
    [style.--row]="Rows"
    [style.--col]="Cols"
    [style.--GridParentDivHeight]="GridParentDivHeight"
    [style.height]="GridParentDivHeight"
    style="
      width: 100%;
      position: relative;
      min-height: 120px;
      min-width: 20%;
      padding: 0px;
    ">
    <div class="child-grid">
      <div
        *ngFor="let grid of GridArray; let i = index"
        class="child-grid-item"
        [id]="'div' + GridConfig.id + '_' + i">
        <lib-i2v-video-grid
          *ngIf=" gridMode=='general' && grid != '' && grid.ComponentName == 'Video'"
          [resource]="grid.camera"
          [playerServerIp]="playerServerIp"
          [streamerIp]="streamerIp"
          (VideoStartedFromi2vVideoGrid)="onVideoStarted($event)"
          (CloseLiveFeed)="closeElement($event)"></lib-i2v-video-grid>
      </div>
    </div>
  </div>
</div>
